import React, { Fragment } from "react";
import { withStyles } from "material-ui/styles";
import moment from "moment";
import TotalES from "components/ReportDetail/TotalES";
import TotalESIndex from "components/ReportDetail/TotalESIndex";
import MeasureSize from "components/ReportDetail/MeasureSize";
import StrengthOfESAndRelationship from "components/ReportDetail/StrengthOfESAndRelationship";
import BubbleChart from "components/ReportDetail/BubbleChart";
import QuestionResult from "components/ReportDetail/QuestionResult";
import MeasureSizeEachAttr from "components/ReportDetail/MeasureSizeEachAttr";
import CInput from "uis/CInput";
import { Button } from "material-ui";
import CTable, {
  CTableHead,
  CTableBody,
  CTableRow,
  CHeadCell,
  CBodyCell
} from "uis/CTable";
import ErrorMessage from "components/ErrorMessage";
import CircularProgress from "material-ui/Progress/CircularProgress";
import { isAdmin } from "utils/formatter";

const styles = theme => ({
  container: {
    padding: 20,
    margin: "20px auto",
    width: 1100
  },
  reportTitle: { fontSize: 30, textAlign: "center" },
  chapter: {
    paddingTop: 70,
    paddingLeft: 20
  },
  chapterTitle: {
    fontSize: 20,
    fontWeight: 600
  },
  section: {
    paddingLeft: 20
  },
  sectionTitle: {
    fontWeight: 600,
    display: "inline-block"
  },
  attrResultTable: {
    backgroundColor: "#7299d2",
    color: "white"
  },
  row: {
    lineHeight: "2rem"
  },
  result: {
    marginBottom: 50
  },
  resultTitle: {
    textAlign: "center",
    fontSize: 24,
    fontWeight: 600
  },
  paragraph: {
    fontWeight: 600
  },
  note: {
    border: "1px solid #9e9e9e",
    margin: 10,
    marginLeft: 200,
    backgroundColor: "rgba(139, 195, 74, 0.2)",
    padding: 10
  },
  rankingComment: {
    marginTop: 10,
    padding: 4,
    width: "99% !important",
    color: "#3f51b5",
    fontSize: 14,
    border: "1px solid #80bdff",
    boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    lineHeight: '1.2em',
    overflow: "hidden"
  },
  deleteBtn: {
    backgroundColor: theme.palette.remove.dark,
    "&:hover": {
      backgroundColor: theme.palette.remove.light
    }
  },

  errorMessage: {
    margin: 10
  }
});

class ReportDetail extends React.Component {
  componentWillMount() {
    this.props.fetchReportDetail();
  }
  componentWillUnmount() {
    this.props.initReportDetail();
  }
  render() {
    const { classes, reportDetail } = this.props;
    const {
      description,
      summaryResult,
      ranking,
      distribution,
      engagement,
      question1,
      question2,
      question3,
      question4,
      question5,
      question6,
      question7,
      question8,
      question9,
      question10,
      question11,
      question12,
      question13,
      measureSizeEachAttr,
      errors
    } = reportDetail;
    const attrItem = new URLSearchParams(this.props.location.search).get('attr_item');
    if (errors.length > 0) {
      return (
        <ErrorMessage messages={errors} className={classes.errorMessage} />
      );
    }
    if (description.termStart === "") {
      return (
        <div
          style={{ display: "flex", justifyContent: "center", marginTop: 100 }}
        >
          <CircularProgress size={100} />
        </div>
      );
    }

    return (
      <div className={classes.container} style={{ backgroundColor: "white" }}>
        <div className={classes.reportTitle}>NiserES 調査結果レポート</div>
        {/* １．調査概要 */}
        <section className={classes.chapter} id="description">
          <div className={classes.chapterTitle}>１．調査概要</div>
          <div className={classes.section}>
            <div className={classes.row}>
              <span className={classes.sectionTitle} style={{ width: 170 }}>
                （１）調査時期
              </span>
              <span>
                {moment(description.termStart).format("YYYY年MM月DD日")} 〜{" "}
                {moment(description.termEnd).format("YYYY年MM月DD日")}
              </span>
            </div>
            <div className={classes.row}>
              <span className={classes.sectionTitle} style={{ width: 170 }}>
                （２）調査数
              </span>
              <span style={{ display: "inline-block", width: 150 }}>
                回収件数:
              </span>
              <span style={{ fontWeight: 600 }}>{description.numbers}</span>
              <span
                style={{ display: "inline-block", width: 150, marginLeft: 100 }}
              >
                回答率:
              </span>
              <span style={{ fontWeight: 600 }}>
                {description.answerRate} ％
              </span>
            </div>
            <div className={classes.row}>
              <span className={classes.sectionTitle} style={{ width: 170 }}>
                （３）属性別回答者数
              </span>
              <div style={{ padding: "0 100px" }}>
                <CTable>
                  <CTableHead>
                    <CTableRow>
                      <CHeadCell className={classes.attrResultTable}>
                        属性区分
                      </CHeadCell>
                      <CHeadCell className={classes.attrResultTable}>
                        詳細区分
                      </CHeadCell>
                      <CHeadCell className={classes.attrResultTable}>
                        人数
                      </CHeadCell>
                      <CHeadCell className={classes.attrResultTable}>
                        構成比
                      </CHeadCell>
                    </CTableRow>
                  </CTableHead>
                  <CTableBody>
                    {description.answers.map(attr =>
                      attr.details.map((detail, i) => (
                        <CTableRow
                          key={detail.name}
                          style={{
                            backgroundColor:
                              attr.attrName === "合計"
                                ? "rgba(0, 220, 255, 0.3)"
                                : null
                          }}
                        >
                          {i === 0 && (
                            <CBodyCell rowSpan={attr.details.length}>
                              {attr.attrName}
                            </CBodyCell>
                          )}
                          <CBodyCell>{detail.name}</CBodyCell>
                          <CBodyCell right>{detail.numbers}</CBodyCell>
                          <CBodyCell right>{detail.rate}%</CBodyCell>
                        </CTableRow>
                      ))
                    )}
                  </CTableBody>
                </CTable>
              </div>
            </div>
            <div className={classes.row}>
              <span className={classes.sectionTitle} style={{ width: 170 }}>
                （４）調査方法
              </span>
              <span>{description.method}</span>
            </div>
            <div className={classes.row}>
              <span className={classes.sectionTitle} style={{ width: 140 }}>
                （５）結果の見方
              </span>
              <span style={{ display: "inline-block", marginLeft: 10 }}>
                【Step1】
              </span>
              <div style={{ display: "inline-grid" }}>
                <span>
                  計６３の設問への回答を用いて算出した
                  <span style={{ color: "red" }}>総合満足度指数及びエンゲージメント指数</span>と
                  <span style={{ color: "red" }}>１３の尺度</span>をみる。
                </span>
                <span>
                  総合満足度指数及びエンゲージメント指数と１３の尺度において、特に
                  <span style={{ textDecoration: "underline" }}>
                    値が５０から離れている部分
                  </span>に着目する。
                </span>
              </div>
            </div>
            <div className={classes.note}>
              <div style={{ fontWeight: 600, textDecoration: "underline" }}>
                １３の尺度とは・・・
              </div>
              <div>
                <span style={{ fontWeight: 600 }}>
                  ①会社への共感、②労働時間管理・福利厚生、③評価・処遇、④給与、⑤仕事の設計と配分、⑥上司の管理・監督、⑦同僚との関係、⑧関連部署との関係、⑨職場環境(物理的環境)、⑩仕事の充実、⑪仕事の負荷、⑫顧客との関係、⑬能力開発
                </span>
                の１３項目の評価をそれぞれ１００点満点の点数で表したもの。尺度の算出は、３〜８の設問の単純平均値を１００点満点に指数化することにより行う。５０点が評価の中間点になり、それ以上の場合は肯定的、それ以下の場合は否定的な評価となる。
              </div>
            </div>
            <div className={classes.note}>
              <div style={{ fontWeight: 600, textDecoration: "underline" }}>
                総合満足度指数とは・・・
              </div>
              <div>
                Ｑ６３の設問
                <span style={{ color: "red", textDecoration: "underline" }}>
                  「当社に対して、総合的に満足している」の結果
                </span>を１００点満点に指数化したもの。ここでは
                <span style={{ textDecoration: "underline" }}>
                  「当社に対して総合的に満足している度合い」を「従業員満足度」と定義する。
                </span>
                １３の尺度と同様に５０点が中間点で、肯定的なほど１００点満点に、否定的なほど０点に近づく。
              </div>
            </div>
            <div className={classes.note}>
              <div style={{ fontWeight: 600, textDecoration: "underline" }}>
                エンゲージメント指数とは・・・
              </div>
              <div>
                Ｑ４５の設問
                <span style={{ color: "red", textDecoration: "underline" }}>
                  「現在の仕事にやりがいを感じている」の結果
                </span>を１００点満点に指数化したもの。ここでは
                <span style={{ textDecoration: "underline" }}>
                  「現在の仕事にやりがいを感じている度合い」を「エンゲージメント指数」と定義する。
                </span>
                １３の尺度と同様に５０点が中間点で、肯定的なほど１００点満点に、否定的なほど０点に近づく。
              </div>
            </div>
            <div>
              <span style={{ marginLeft: 150 }}>【Step2】</span>
              <div style={{ display: "inline-grid" }}>
                <span>
                  算出した尺度と従業員満足度及びエンゲージメント指数の関係性の強さを表す指標となる
                  <span style={{ color: "red" }}>相関係数</span>をみる。
                </span>
                <span>
                  <span style={{ textDecoration: "underline" }}>
                    相関係数が高いほど従業員満足度及びエンゲージメント指数との関係性が強くなる
                  </span>。
                </span>
              </div>
            </div>
            <div className={classes.note}>
              <div style={{ fontWeight: 600, textDecoration: "underline" }}>
                相関係数とは・・・
              </div>
              <div>
                ２つの項目(数値の列)の間の関係性の強さを表す統計的な指数の一つであり、その２つの項目が正の関係にあるときは正の値、負の関係にあるときは負の値となる。値が１や－１近づくほどその関係性は強くなる(０に近づくほど弱くなる)。
              </div>
            </div>
            <div>
              <span style={{ marginLeft: 150 }}>【Step3】</span>
              <div style={{ display: "inline-grid" }}>
                <span style={{ textDecoration: "underline" }}>
                  <span style={{ fontWeight: 600 }}>「値が小さく」</span>かつ
                  <span style={{ fontWeight: 600 }}>
                    「従業員満足度及びエンゲージメント指数と関係性が強い(相関係数が大きい)」
                  </span>尺度
                </span>に着目する。
                <span>
                  それらの尺度を構成する設問の結果を確認し、その中でも特に否定的な回答の多い項目を課題と
                </span>
                <span>して捉える。</span>
              </div>
            </div>
            <div>
              <span className={classes.sectionTitle} style={{ width: 170 }}>
                （６）留意点
              </span>
            </div>
            <div style={{ marginLeft: 200 }}>
              <div style={{ border: "1px solid #9e9e9e", padding: 10 }}>
                {description.note || ""}
              </div>
            </div>
          </div>
        </section>

        {/* ２．結果のまとめ */}
        <section className={classes.chapter} id="summary">
          <div className={classes.chapterTitle}>２．結果のまとめ</div>
          <div className={classes.section}>
            <div style={{ marginBottom: 30 }}>
              <span className={classes.sectionTitle}>
                （１）全体の総合満足度の分析
              </span>
              <div style={{ width: 700, margin: "10px auto" }}>
                <TotalES data={summaryResult.totalES.data} />
                <div>
                  ※
                  本調査では、「総合満足度＝当社に対して総合的に満足している値」と定義
                </div>
              </div>
            </div>

            <div style={{ marginBottom: 30 }}>
              <span className={classes.sectionTitle}>（２）総合満足度指数</span>
              <div className={classes.row}>
                <span>
                  <span
                    style={{
                      display: "inline-block",
                      width: 150,
                      fontSize: 20,
                      color: "red"
                    }}
                  >
                    全体の指数:
                  </span>
                  <span
                    style={{
                      display: "inline-block",
                      width: 50,
                      fontSize: 20,
                      color: "red"
                    }}
                  >
                    {Number(summaryResult.totalESIndex.index).toFixed(1)}
                  </span>
                  <span>
                    ※総合満足度(上のQ63の結果)を100点満点(最少0、最大100)に指数化して表示。
                  </span>
                </span>
              </div>
              <TotalESIndex
                data={summaryResult.totalESIndex.data}
                attrCount={summaryResult.totalESIndex.attrCount}
                index={summaryResult.totalESIndex.index}
              />
              <div>
                {isAdmin() ? (
                  <Fragment>
                    <CInput
                      id="indexComment"
                      inputProps={{
                        "aria-label": "Description"
                      }}
                      rows="7"
                      classes={{
                        inputMultiline: classes.rankingComment
                      }}
                      value={summaryResult.comment}
                      fullWidth
                      multiline
                      onChange={e =>
                        this.props.changeComment(
                          "summaryResult",
                          e.target.value
                        )
                      }
                    />
                    <div style={{ textAlign: "right" }}>
                      <Button
                        dense
                        raised
                        className={classes.deleteBtn}
                        onClick={() =>
                          this.props.changeComment(
                            "summaryResult",
                            summaryResult.initComment
                          )
                        }
                      >
                        変更前に戻す
                      </Button>
                      <Button
                        dense
                        raised
                        className={classes.statusBtn}
                        style={{ marginLeft: 15 }}
                        onClick={() =>
                          this.props.updateComment(
                            "summaryResult",
                            "indexComment",
                            summaryResult.comment,
                            attrItem
                          )
                        }
                      >
                        変更を保存
                      </Button>
                    </div>
                  </Fragment>
                ) : (
                  <div className={classes.rankingComment}>
                    {summaryResult.initComment}
                  </div>
                )}
              </div>
            </div>
            <div style={{ marginBottom: 30 }}>
              <div className={classes.row}>
                <span className={classes.sectionTitle}>
                  （３）全体の「尺度の大きさ」と「満足度との関係性の強さ」ランキング
                </span>
              </div>
              <div
                className={classes.row}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <div style={{ width: 500 }}>
                  <MeasureSize
                    data={ranking.measureSize.data}
                    xCategories={ranking.measureSize.xCategories}
                  />
                </div>
                <div style={{ width: 500 }}>
                  {ranking.strengthOfESAndRelationship.error.length > 0 ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: 400
                      }}
                    >
                      <span>
                        {ranking.strengthOfESAndRelationship.error[0]}
                      </span>
                    </div>
                  ) : (
                    <StrengthOfESAndRelationship
                      data={ranking.strengthOfESAndRelationship.data}
                      xCategories={
                        ranking.strengthOfESAndRelationship.xCategories
                      }
                    />
                  )}
                </div>
              </div>
              <div style={{ border: "1px solid #9e9e9e", padding: 10 }}>
                <span>
                  ※「相関係数」の大まかな目安は、0.7以上で“関係が強い”、0.3〜0.7で“関係がある”、0.3以下で“関係が弱いまたはない”である。信頼できる相関係数の値を得るにはある程度のサンプル数が必要なため、全体の結果のみを表示する。
                </span>
              </div>
              <div
                style={{
                  border: "1px solid #9e9e9e",
                  padding: 10,
                  marginTop: 20
                }}
              >
                <div>
                  尺度ランキングで尺度の値が50を下回るものは、従業員の評価が“悪い(否定的な)”方に振れているため要注意である。<br />また、右の図は１３の尺度と総合満足度の関係性の強さ(相関係数の大きさ)を表している。そのランキングで上位に位置する尺度ほ<br />ど、満足度に影響を及ぼしている可能性が高い。
                </div>
                {isAdmin() ? (
                  <Fragment>
                    <CInput
                      id="rankingComment"
                      inputProps={{
                        "aria-label": "Description"
                      }}
                      rows="7"
                      classes={{
                        inputMultiline: classes.rankingComment
                      }}
                      value={ranking.comment}
                      fullWidth
                      multiline
                      onChange={e =>
                        this.props.changeComment("ranking", e.target.value)
                      }
                    />
                    <div style={{ textAlign: "right" }}>
                      <Button
                        dense
                        raised
                        className={classes.deleteBtn}
                        onClick={() =>
                          this.props.changeComment(
                            "ranking",
                            ranking.initComment
                          )
                        }
                      >
                        変更前に戻す
                      </Button>
                      <Button
                        dense
                        raised
                        className={classes.statusBtn}
                        style={{ marginLeft: 15 }}
                        onClick={() =>
                          this.props.updateComment("ranking",
                          "rankingComment",
                          ranking.comment,
                          attrItem
                          )
                        }
                      >
                        変更を保存
                      </Button>
                    </div>
                  </Fragment>
                ) : (
                  <div className={classes.rankingComment}>
                    {ranking.initComment}
                  </div>
                )}
              </div>
            </div>
            <div style={{ marginBottom: 30 }}>
              <div className={classes.row}>
                <span className={classes.sectionTitle}>
                  （４）全体の「尺度の大きさ」と「満足度との関係性の強さ」の分布
                </span>
              </div>
              <div>
                <BubbleChart
                  title="尺度の大きさ（縦）と満足度との関係性の強さ（横）"
                  xtitle="満足度との相関係数"
                  ytitle="尺度の大きさ"
                  xdata={distribution.bubbleChart.xdata}
                  ydata={distribution.bubbleChart.ydata}
                />
              </div>
              <div>
                {isAdmin() ? (
                  <Fragment>
                    <CInput
                      id="distributionComment"
                      inputProps={{
                        "aria-label": "Description"
                      }}
                      rows="7"
                      classes={{
                        inputMultiline: classes.rankingComment
                      }}
                      value={distribution.comment}
                      fullWidth
                      multiline
                      onChange={e =>
                        this.props.changeComment("distribution", e.target.value)
                      }
                    />
                    <div style={{ textAlign: "right" }}>
                      <Button
                        dense
                        raised
                        className={classes.deleteBtn}
                        onClick={() =>
                          this.props.changeComment(
                            "distribution",
                            distribution.initComment
                          )
                        }
                      >
                        変更前に戻す
                      </Button>
                      <Button
                        dense
                        raised
                        className={classes.statusBtn}
                        style={{ marginLeft: 15 }}
                        onClick={() =>
                          this.props.updateComment(
                            "distribution",
                            "distributionComment",
                            distribution.comment,
                            attrItem
                          )
                        }
                      >
                        変更を保存
                      </Button>
                    </div>
                  </Fragment>
                ) : (
                  <div className={classes.rankingComment}>
                    {distribution.initComment}
                  </div>
                )}
              </div>
            </div>
            
            <div className={classes.row}>
              <span className={classes.sectionTitle}>
                （５）全体の「尺度の大きさ」と「エンゲージメントとの関係性の強さ」の分布
              </span>
            </div>
            <div>
              <BubbleChart
                title="尺度の大きさ（縦）とエンゲージメントとの関係性の強さ（横）"
                xtitle="エンゲージメントとの相関係数"
                ytitle="尺度の大きさ"
                xdata={engagement.bubbleChart.xdata}
                ydata={engagement.bubbleChart.ydata}
              />
            </div>
            <div>
              {isAdmin() ? (
                <Fragment>
                  <CInput
                    id="engagementComment"
                    inputProps={{
                      "aria-label": "Engagement"
                    }}
                    rows="7"
                    classes={{
                      inputMultiline: classes.rankingComment
                    }}
                    value={engagement.comment}
                    fullWidth
                    multiline
                    onChange={e =>
                      this.props.changeComment("engagement", e.target.value)
                    }
                  />
                  <div style={{ textAlign: "right" }}>
                    <Button
                      dense
                      raised
                      className={classes.deleteBtn}
                      onClick={() =>
                        this.props.changeComment(
                          "engagement",
                          engagement.initComment
                        )
                      }
                    >
                      変更前に戻す
                    </Button>
                    <Button
                      dense
                      raised
                      className={classes.statusBtn}
                      style={{ marginLeft: 15 }}
                      onClick={() =>
                        this.props.updateComment(
                          "engagement",
                          "engagementComment",
                          engagement.comment,
                          attrItem
                        )
                      }
                    >
                      変更を保存
                    </Button>
                  </div>
                </Fragment>
              ) : (
                <div className={classes.rankingComment}>
                  {engagement.initComment}
                </div>
              )}
            </div>
          </div>
        </section>

        {/* ３．全体の尺度別設問の結果 */}
        <section className={classes.chapter} id="overall_result">
          <div className={classes.chapterTitle}>３．全体の尺度別設問の結果</div>
          <div className={classes.section}>
            <div className={classes.result}>
              <div className={classes.resultTitle}>
                「①会社への共感」に関する設問の結果
              </div>
              <div>
                <QuestionResult
                  dataMain={question1.dataMain}
                  dataSub={question1.dataSub}
                  category={question1.category}
                />
              </div>
            </div>
            <div className={classes.result}>
              <div className={classes.resultTitle}>
                「②労働時間管理・福利厚生」に関する設問の結果
              </div>
              <div>
                <QuestionResult
                  dataMain={question2.dataMain}
                  dataSub={question2.dataSub}
                  category={question2.category}
                />
              </div>
            </div>
            <div className={classes.result}>
              <div className={classes.resultTitle}>
                「③評価・処遇」に関する設問の結果
              </div>
              <div>
                <QuestionResult
                  dataMain={question3.dataMain}
                  dataSub={question3.dataSub}
                  category={question3.category}
                />
              </div>
            </div>
            <div className={classes.result}>
              <div className={classes.resultTitle}>
                「④給与」に関する設問の結果
              </div>
              <div>
                <QuestionResult
                  dataMain={question4.dataMain}
                  dataSub={question4.dataSub}
                  category={question4.category}
                />
              </div>
            </div>
            <div className={classes.result}>
              <div className={classes.resultTitle}>
                「⑤仕事の設計と配分」に関する設問の結果
              </div>
              <div>
                <QuestionResult
                  dataMain={question5.dataMain}
                  dataSub={question5.dataSub}
                  category={question5.category}
                />
              </div>
            </div>
            <div className={classes.result}>
              <div className={classes.resultTitle}>
                「⑥上司の管理・監督」に関する設問の結果
              </div>
              <div>
                <QuestionResult
                  dataMain={question6.dataMain}
                  dataSub={question6.dataSub}
                  category={question6.category}
                />
              </div>
            </div>
            <div className={classes.result}>
              <div className={classes.resultTitle}>
                「⑦同僚との関係」に関する設問の結果
              </div>
              <div>
                <QuestionResult
                  dataMain={question7.dataMain}
                  dataSub={question7.dataSub}
                  category={question7.category}
                />
              </div>
            </div>
            <div className={classes.result}>
              <div className={classes.resultTitle}>
                「⑧関連部署との関係」に関する設問の結果
              </div>
              <div>
                <QuestionResult
                  dataMain={question8.dataMain}
                  dataSub={question8.dataSub}
                  category={question8.category}
                />
              </div>
            </div>
            <div className={classes.result}>
              <div className={classes.resultTitle}>
                「⑨職場環境（物理的環境）」に関する設問の結果
              </div>
              <div>
                <QuestionResult
                  dataMain={question9.dataMain}
                  dataSub={question9.dataSub}
                  category={question9.category}
                />
              </div>
            </div>
            <div className={classes.result}>
              <div className={classes.resultTitle}>
                「⑩仕事の充実」に関する設問の結果
              </div>
              <div>
                <QuestionResult
                  dataMain={question10.dataMain}
                  dataSub={question10.dataSub}
                  category={question10.category}
                />
              </div>
            </div>
            <div className={classes.result}>
              <div className={classes.resultTitle}>
                「⑪仕事の負荷」に関する設問の結果
              </div>
              <div>
                <QuestionResult
                  dataMain={question11.dataMain}
                  dataSub={question11.dataSub}
                  category={question11.category}
                />
              </div>
            </div>
            <div className={classes.result}>
              <div className={classes.resultTitle}>
                「⑫顧客との関係」に関する設問の結果
              </div>
              <div>
                <QuestionResult
                  dataMain={question12.dataMain}
                  dataSub={question12.dataSub}
                  category={question12.category}
                />
              </div>
            </div>
            <div className={classes.result}>
              <div className={classes.resultTitle}>
                「⑬能力開発」に関する設問の結果
              </div>
              <div>
                <QuestionResult
                  dataMain={question13.dataMain}
                  dataSub={question13.dataSub}
                  category={question13.category}
                />
              </div>
            </div>
          </div>
        </section>

        {/* ４．属性別尺度の結果 */}
        <section className={classes.chapter} id="attr_result">
          <div className={classes.chapterTitle}>４．属性別尺度の結果</div>
          <div className={classes.section}>
            {measureSizeEachAttr.map((v, i) => (
              <Fragment key={`measure-size-attr-${i}`}>
                <div className={classes.result}>
                  <div className={classes.resultTitle}>
                    {`「${v.title}」の尺度`}
                  </div>
                  <div>
                    <MeasureSizeEachAttr
                      title={`「${v.title}」の尺度`}
                      columnData={v.columnData}
                      lineData={v.lineData}
                    />
                  </div>
                </div>
              </Fragment>
            ))}
          </div>
        </section>
      </div>
    );
  }
}

export default withStyles(styles)(ReportDetail);



// WEBPACK FOOTER //
// ./src/components/ReportDetail/index.jsx